import { createCustomEnum } from "./customEnum";

const TerminalProductNameTypes = createCustomEnum({
	Calendarise: {
		name: "calendarise",
		value: 0,
		displayName: "Calendarise",
	},
	NailSoft: {
		name: "nail_soft",
		value: 1,
		displayName: "NailSoft",
	},
	Other: {
		name: "other",
		value: 2,
		displayName: "Other",
	},
});

export default TerminalProductNameTypes;
